import React from "react";
import { DropdownCrossIcon, RightArrowIcon } from "../../Icons";
import { Link } from "react-router-dom";

const SmallButton = ({ text, cancel, back, href, ...props }) => {
  return (
    <>
      {href ? (
        <div className="flex items-center">
          <Link to={href}>
            <button
              className="flex items-center underline px-3 py-2 rounded-full text-sm font-medium transition-all duration-300 ease-in-out small-button"
              {...props}
            >
              {cancel && <DropdownCrossIcon />}
              {back && <RightArrowIcon className={"rotate-180"} />}
              {text}
            </button>
          </Link>
        </div>
      ) : (
        <div className="flex items-center">
          <button
            className="flex items-center underline px-3 py-2 rounded-full text-sm font-medium transition-all duration-300 ease-in-out small-button-link"
            {...props}
          >
            {cancel && <DropdownCrossIcon />}
            {back && <RightArrowIcon className={"rotate-180"} />}
            {text}
          </button>
        </div>
      )}
    </>
  );
};

export default SmallButton;
